export * from "./product-trends/product-trends.component";